import Chart from './Chart';
import Formatter from '../Formatter';

class ColumnChart extends Chart {
  /**
   * Construir el objeto para la gráfica
   */
  columnChartBuild(labelName = null) {
    const elthis = this;

    return {
      colors: Chart.getColorPalette(),
      chart: {
        type: this.getChartType('column'),
        zoomType: 'x',
        height: this.height,
      },
      title: {
        text:
          this.chartObject.Titulo || this.chartObject.Titulo === ''
            ? this.chartObject.Titulo
            : this.chartObject.title.text,
      },
      subtitle: {
        text:
          this.chartObject.STitulo || this.chartObject.STitulo === ''
            ? this.chartObject.STitulo
            : this.chartObject.subtitle.text,
      },
      xAxis: this.chartObject.drilldown
        ? { type: 'category' }
        : this.chartObject.xAxis[0] && this.chartObject.xAxis[0].categories
        ? this.chartObject.xAxis
        : {
            categories: this.chartObject.xAxis,
            crosshair: true,
            title: this.getXAxisName(),
            labels: {
              style: {
                color: '#6e6e70',
              },
              rotation: this.getRotationLabel(),
            },
          },
      yAxis: Array.isArray(this.chartObject.yAxis)
        ? this.chartObject.yAxis
        : {
            ...(this.getTicksData() ? this.getTicksData() : { min: 0 }),
            title: {
              text: this.chartObject.yAxis
                ? typeof this.chartObject.yAxis === 'string'
                  ? this.chartObject.yAxis
                  : this.chartObject.yAxis.title.text
                : '',
            },
            ...this.getPlotBands(),
            labels: {
              style: {
                color: '#6e6e70',
              },
            },
            ...this.getPlotLines(),
            ...this.getTicksData(),
          },
      tooltip: this.showValueSuffixFromOrigin()
        ? {}
        : {
            formatter: function () {
              return elthis.getTooltip(this, labelName);
            },
            useHTML: true,
          },
      plotOptions: {
        column: {
          pointPadding: 0.05,
          borderWidth: 0.5,
          dataLabels: {
            enabled: this.showDataLabels(),
            color: 'gray',
            formatter: function () {
              let suffix = elthis.getSuffix(this.series);

              return this.y != 0 || elthis.showZeros
                ? `${Formatter.formatMoney(
                    this.y,
                    elthis.getDataNumbersDecimal()
                  )} ${elthis.percent ? '%' : suffix}`
                : null;
            },
          },
          enableMouseTracking: this.isEnableMouseTracking(),
        },
      },
      series: this.chartObject.values
        ? this.chartObject.values
        : this.chartObject.series,
      drilldown: this.chartObject.drilldown ? this.chartObject.drilldown : {},
      exporting: {
        menuItemDefinitions: {
          viewFullscreen: {
            onclick: function () {
              sessionStorage.setItem('esri-fullscreen', 'false');
              this.fullscreen && this.fullscreen.toggle();
            },
          },
        },
      },
    };
  }
}

export default ColumnChart;
